export const theTradedFactoryProperties = [
  { prop: 'selection', type: 'selection', labelWidth: '48px' },
  { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
  {
    label: '工厂简称',
    prop: 'supp_abbr',
    itemType: 'input',
    input: false
  },
  {
    label: '面辅料价格',
    prop: 'material_prices',
    itemType: 'input',
    input: false
  },
  {
    label: '人工工资',
    prop: 'labor_wages',
    itemType: 'input',
    input: false
  },
  {
    label: '税额合计',
    prop: 'total_tax_amount',
    itemType: 'input',
    input: false
  },
  {
    label: '含税金额',
    prop: 'tax_inclusive_amount',
    itemType: 'input',
    input: false
  }
];
